import { render } from "./MenuButtons.vue?vue&type=template&id=2944c913"
import script from "./MenuButtons.vue?vue&type=script&lang=js"
export * from "./MenuButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__